import React from 'react';

import l10n from "../../l10n/localization";
import Loader from "../common/Loader";
import sematable, {Table} from "sematable";
import {Button, NavItem} from "react-materialize";
import CargoTabs from "./CargoTabs";
import Date from "./tableComponents/Date";
import ShortagePercent from "./tableComponents/ShortagePercent";
import * as creationActions from "../../actions/creation";
import Port from "./tableComponents/Port";
import ShortageTonnes from "./tableComponents/ShortageTonnes";
import Dropdown from "../common/Dropdown";
import * as cargoActions from "../../actions/cargo";
import Dialog from "react-toolbox/lib/dialog/Dialog";

export const CARGOES_TABLE = 'CARGOES_TABLE';

const columns = [
    {key: 'id', hidden: true, primaryKey: true},
    {key: 'commodityName', header: l10n.cargo.commodity, sortable: true, searchable: true, filterable: true},
    {
        key: 'quantity',
        header: l10n.common.quantity,
        sortable: true,
        Component: (item) =>
            <span>{item.row.quantity !== null && item.row.quantity.toLocaleString('en-US').replace(/,/g, " ")}</span>
    },
    //{key: 'perTonUsd', header: l10n.cargo.perTonUsd, sortable: true, searchable: true, filterable: true},
    //{key: 'value', header: l10n.common.value, sortable: true},
    {
        key: 'outturnTonnes',
        header: l10n.cargo.outturnTonnes,
        sortable: true,
        Component: (item) =>
            <span>{item.row.outturnTonnes !== null && item.row.outturnTonnes.toLocaleString('en-US').replace(/,/g, " ")}</span>
    },
    {key: 'shortageTonnes', header: l10n.cargo.shortageTonnes, sortable: true, Component: ShortageTonnes},
    {key: 'shortagePercent', header: l10n.cargo.shortagePercent, sortable: true, Component: ShortagePercent},
    {key: 'stowage', header: l10n.cargo.stowage, sortable: true, searchable: true, filterable: true},
    {
        key: 'loadPort',
        header: l10n.port.load,
        sortable: true,
        searchable: true,
        filterable: true,
        Component: (props) => <Port {...props} operation={"LOAD"}/>
    },
    {
        key: 'dischargePort',
        header: l10n.port.discharge,
        sortable: true,
        searchable: true,
        filterable: true,
        Component: (props) => <Port {...props} operation={"DISCHARGE"}/>
    },
    //{key: 'customerReference', header: l10n.cargo.customerReference, sortable: true, searchable: true, filterable: true},
    {key: 'receiver', header: l10n.cargo.receiver, sortable: true, searchable: true, filterable: true},
    {key: 'blNumber', header: l10n.cargo.blNumber, sortable: true, searchable: true, filterable: true},
    {key: 'blDate', header: l10n.cargo.blDate, sortable: true, searchable: true, Component: Date},
    {key: 'actions', header: '', className: 'action-column'}
];

class CargoTable extends React.Component {
    state = {
        dialogActive: false,
        cargoID: null,
    };

    addActions() {
        this.props.columns[this.props.columns.length - 1].Component = ({row}) => {
            return (
                <div>
                    <Button floating onClick={() => this.props.openDrawer(CargoTabs, {
                        item: row,
                        fog: this.props.fog
                    }, creationActions.destroyingnewlyCreatedCargo())} icon="edit" className="edit-button" disabled={this.props.deleting} />
                    <Dropdown trigger={(props) => (
                        <Button floating icon="more_vert" className="more-button" onClick={props.onClick}/>)}>
                        <NavItem>
                            <Button disabled={this.props.deleting} className="transparent" onClick={() => this.setState({...this.state, dialogActive: true, cargoID: row.id})}>
                                {l10n.common.remove}
                            </Button>
                            <Button disabled={this.props.deleting} className="transparent" onClick={() => this.props.dispatch(cargoActions.duplicateCargo(row.id, this.props.fog.id))} >
                                {l10n.common.duplicate}
                            </Button>
                        </NavItem>
                    </Dropdown>
                </div>
            )
        };
    }

    deleteFog() {
        if (this.state.cargoID !== null) {
            this.props.dispatch(cargoActions.deleteCargo(this.state.cargoID, this.props.fog.id));
        }
        this.setState({...this.state, dialogActive: false, cargoID: null});
    }

    render() {
        this.addActions();

        if (this.props.loading || this.props.data === undefined) {
            return (<div><Loader/></div>)
        }

        return (
            <div>
                <Table {...this.props} data={this.props.data} css={{display: 'block'}}/>
                <Dialog
                    actions={[
                        { label: "Cancel", onClick: () => this.setState({...this.state, dialogActive: false, cargoID: null}) },
                        { label: "Yes", onClick: () => this.deleteFog() }
                    ]}
                    active={this.state.dialogActive}
                    title='Confirmation'>
                    <p>Are you sure you want to delete this cargo ?</p>
                </Dialog>
            </div>
        )
    }
}

export default sematable(CARGOES_TABLE, CargoTable, columns, {
    defaultPageSize: -1,
    autoHidePagination: true,
    showPageSize: false
});


// WEBPACK FOOTER //
// ./src/components/cargo/CargoTable.js